import type { App } from 'vue'
import { Mask, type MaskInputOptions } from 'maska'
import { vMaska } from 'maska/vue'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $masks: {
      cellphone: Mask
      cep: Mask
      cpf: Mask
      cnpj: Mask
      datetime: Mask
      currency: MaskInputOptions
      percentage: MaskInputOptions
    }
  }
}

export function register(app: App) {
  app.directive('maska', vMaska)

  app.config.globalProperties.$masks = {
    cellphone: new Mask({ mask: '(##) #####-####' }),
    cep: new Mask({ mask: '#####-###' }),
    cpf: new Mask({ mask: '###.###.###-##' }),
    cnpj: new Mask({ mask: '##.###.###/####-##' }),
    datetime: new Mask({ mask: '##/##/#### ##:##:##' }),
    currency: {
      mask: '###.###.###,##',
      reversed: true,
      preProcess(value) {
        return value.padStart(3, '0')
      },
      postProcess(v: string) {
        if (v.length < 1) return v
        // To prevent . and , from appering in front of the value
        const firstIsDigit = !isNaN(parseInt(v[0]))
        return `R$ ${firstIsDigit ? v : v.substring(1)}`
      },
    },
    percentage: {
      mask: '###',
      postProcess(v: string) {
        const num = parseInt(v)
        if (isNaN(num)) return '0'
        if (num > 100) return '100'
        return `${num}%`
      },
    },
  }
}
